import { create } from 'zustand';
import type { MockState } from './types';
import { initialMockState } from './fixtures';

/**
 * Runtime mock data store (in-memory only — TC-008).
 *
 * - Fixtures seed the store on boot.
 * - Mutations survive SPA navigation until a full page reload (FR-200, FR-201).
 * - resetMockData() re-seeds from fixtures without reload (FR-202).
 */

interface MockStore extends MockState {
  resetMockData: () => void;
  /** Apply a partial patch to the root mock state. Intended for demo-time mutations. */
  patch: (partial: Partial<MockState>) => void;
}

// Deep-clone to guarantee fixture fields cannot be mutated by accident.
function cloneInitial(): MockState {
  return JSON.parse(JSON.stringify(initialMockState)) as MockState;
}

export const useMockStore = create<MockStore>((set) => ({
  ...cloneInitial(),
  resetMockData: () => set({ ...cloneInitial() }),
  patch: (partial) => set((state) => ({ ...state, ...partial })),
}));
